import React, { Fragment, useEffect, useRef, useState } from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import DragDrop from "../DragDrop/DragDrop";
import ApprovalsScreen from "./ApprovalsScreen";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import moment from "moment";
import InputMaskReadOnly from "../App/InputMaskReadOnly";
import { useGlobalState } from "../Context/GlobalStateContext";
import DownloadPopup from "../App/DownloadPopup";
export default function AchievementStatusReport() {
  const [showAnimation, setShowAnimation] = useState(false);
  const globalState = useGlobalState();
  const [programList, setProgramList] = useState<any>([]);
  const [quarterList, setQuarterList] = useState<any>([]);

  const [groupList, setGroupList] = useState<any>([]);

  const [filterData, setFilterData] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    PFIGroupIDs: "1",
    IBBScorecardID: 0,
    PFIDealerID: 0,
    PFIBrandID: 2,
  });

  const [downloadInputData, setDownloadInputData] = useState<any>([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState(
    "Data has been exported to file successfully!"
  );

  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = filterData.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = filterData.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = filterData.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = filterData.ProgramID;

    setFilterData((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );
    IBBGroupGetCompleteGridData();
  }, []);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = filterData.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setFilterData((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setFilterData((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    object.sortexpressions = "Description";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[1].length > 0) {
            }
            setGroupList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetDataForAchievementStatusReport() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.numericquarter = filterData.QuarterID;
    object.pfigroupids = filterData.PFIGroupIDs;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetDataForAchievementStatusReport",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          setDownloadInputData(result[0]);
          if (result[0].length > 0) {
            setPopUpFileURL(result[0][0].DownloadData);
            setPopUpMessage("Data has been exported to file successfully!");
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}

      <DownloadPopup
        ShowPopup={showPopUp}
        FileLink={popUpFileURL}
        Message={popUpMessage}
        DownloadPopupCallBack={DownloadPopupCallBack}
      />

      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Achievement Status Report</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div style={{ width: "33.33%" }}>
              <select
                className="select-md"
                value={filterData.ProgramID}
                onChange={(e) => {
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(
                    Number(e.target.value),
                    0,
                    0,
                    0
                  );
                }}
              >
                {programList &&
                  programList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"programtop" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>

              <select
                style={{ marginLeft: 5 }}
                className="select-md"
                value={filterData.QuarterID}
                onChange={(e) => {
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                {quarterList &&
                  quarterList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"quartertop" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>
            <div>
            <select
            className="select-md"
                value={filterData.PFIGroupIDs}
                onChange={(e) =>
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    PFIGroupIDs: Number(e.target.value),
                    ExceptionID: -1,
                  }))
                }
              >
                {groupList &&
                  groupList.map((item: any, index: any) => (
                    <option value={item.IBBGroupID} key={"groupoption" + index}>
                      {item.Name}
                    </option>
                  ))}
              </select>
            </div>
            <span style={{ width: "33.33%" }}></span>

          </div>
          
          <div className="help-btns mt--45">
              <a
                className=""
                onClick={() =>
                  IBBProgramGetDataForAchievementStatusReport()
                }
              >
                Download Report
              </a>
            </div>
        </div>
      </div>

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}

    </>
  );
}
